import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { IParceiro } from '@app/modules/parceiro/model';
import { ParceiroService } from '@app/modules/parceiro/services/parceiro.service';
import { IProfissional } from '@app/modules/profissional/models/profissional.model';
import { ProfissionalService } from '@app/modules/profissional/services/profissional.service';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { Dialog } from 'primeng/dialog';
import { zip } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import {
  ErroMessages,
  IErroMessages,
  ScreenService,
  TokenService
} from 'viggo-sistemas-core-web';
import { Utils } from '../../../../shared/helpers/utils';
import { FastContatoComponent } from '../fast-contato/fast-contato.component';
import { FastEnderecoComponent } from '../fast-endereco/fast-endereco.component';
import { FormInfoProfissionalComponent } from './form-info-profissional/form-info-profissional.component';

@Component({
  selector: 'app-fast-profissional',
  templateUrl: './fast-profissional.component.html',
  styleUrls: ['./fast-profissional.component.scss'],
  providers: [ProfissionalService, ParceiroService]
})
export class FastProfissionalComponent implements AfterViewInit {
  @ViewChild('fastProfissional') fastProfissional: Dialog;
  @ViewChild(FormInfoProfissionalComponent)
  _formInfoProfissional: FormInfoProfissionalComponent;

  @ViewChild(FastEnderecoComponent)
  public _fastEndereco: FastEnderecoComponent;

  @ViewChild(FastContatoComponent)
  public _fastContato: FastContatoComponent;

  form: UntypedFormGroup;

  viewInit = false;

  entity: IProfissional = {
    parceiro: {
      contatos: [],
      enderecos: []
    } as IParceiro
  } as IProfissional;

  constructor(
    public dialogRef: MatDialogRef<FastProfissionalComponent>,
    public profissionalService: ProfissionalService,
    private tokenService: TokenService,
    public screenService: ScreenService,
    private parceiroService: ParceiroService,
    public matSnackBar: MatSnackBar,
    public matDialog: MatDialog,
    public router: Router,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) private data: { entity: IProfissional }
  ) {}

  public setInformacoesParceiro(
    parceiro: IParceiro = { contatos: [], enderecos: [] } as IParceiro
  ): void {
    this.entity.parceiro = parceiro;
    this._fastEndereco.updateFormValue(parceiro.enderecos);
    this._fastContato.updateValues(parceiro);
  }

  get formValid(): boolean {
    return (
      this.viewInit &&
      this._fastEndereco.form.valid &&
      this._formInfoProfissional.form.valid
    );
  }

  get formAddressValid(): boolean {
    if (this.viewInit && this._fastEndereco.form.invalid)
      this._fastEndereco.form.markAllAsTouched();
    return this.viewInit && this._fastEndereco.form.invalid;
  }

  get formDadosValid() {
    if (this.viewInit && this._formInfoProfissional.form.invalid)
      this._formInfoProfissional.form.markAllAsTouched();
    return this.viewInit && this._formInfoProfissional.form.invalid;
  }

  onSubmit(): void {
    var entity: IProfissional = Utils.clearObject<IProfissional>({
      ...this.entity,
      num_conselho: this._formInfoProfissional.getNumConselho(),
      sexo: this._formInfoProfissional.getSexo(),
      parceiro: Utils.clearObject({
        ...this.entity.parceiro,
        ...this._formInfoProfissional.getValues(),
        user_id: this._formInfoProfissional.getUser(),
        enderecos: this._fastEndereco.getValues(),
        contatos: this._fastContato.getValues()
      })
    } as IProfissional);
    delete entity.parceiro.user;
    delete (entity.parceiro as any).sexo;
    delete (entity.parceiro as any).num_conselho;
    entity.parceiro = Utils.trimAttributes(entity.parceiro);
    entity.parceiro = Utils.clearEmptyString(entity.parceiro);
    this.insert(entity);
  }

  insert(entity: IProfissional): void {
    if (entity.parceiro.id) {
      zip(
        this.parceiroService.update({
          ...entity.parceiro
        }),
        this.profissionalService.insert({
          ...entity,
          id: entity.parceiro.id,
          parceiro: undefined
        })
      )
        .pipe(
          mergeMap(([, profissional]) => {
            return this.profissionalService.getEntity(profissional.id, [
              'parceiro'
            ]);
          })
        )
        .subscribe(
          profissional => {
            this.matSnackBar.open('Profissional criado com sucesso.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
            this.dialogRef.close(profissional);
          },
          (err: HttpErrorResponse) => this.displayError(err)
        );
    } else {
      this.parceiroService
        .insert({
          ...entity.parceiro,
          domain_id: this.tokenService.getDomain().id
        })
        .pipe(
          mergeMap(parceiro => {
            return this.profissionalService.insert({
              ...entity,
              id: parceiro.id,
              parceiro: undefined
            });
          }),
          mergeMap(profissional => {
            return this.profissionalService.getEntity(profissional.id, [
              'parceiro'
            ]);
          })
        )
        .subscribe(
          profissional => {
            this.matSnackBar.open('Profissional criado com sucesso.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
            this.dialogRef.close(profissional);
          },
          (err: HttpErrorResponse) => this.displayError(err)
        );
    }
  }

  ngAfterViewInit(): void {
    this.viewInit = true;
    if (this.screenService.detectDeviceInfo().isMobile)
      this.fastProfissional.maximize();
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.matDialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'pi pi-fw pi-info-circle text-orange-500 mb-2 mr-2',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.showMessageObject(err.error);
    // errorMsg.checkError();
  }
}
